import './euras-bank-item.scss';

import { Tooltip } from 'antd';
import { useContext } from 'react';

import { Button, OfferCard } from '@/components/Shared/ui';
import { BANKS_ICONS_NAMES, DictTypes } from '@/constants';
import { ReloadOutlined } from '@/media/antd-icons';
import { useAppSelector } from '@/store';

import { OfferStepContext } from '../../offer-step';
import type { TEurasV1BankOffer } from '../../types/euras-v1.types';

interface IProps {
  bankOffer: TEurasV1BankOffer;
}

const EurasWaitingItem: React.FC<IProps> = ({ bankOffer }) => {
  const { handleChangeEuBankStatus } = useContext(OfferStepContext);
  const { dicts } = useAppSelector((state) => state.dict);

  const bank = dicts?.[DictTypes.Banks]?.getBy.name[bankOffer.bank.name];
  const bankIconName = BANKS_ICONS_NAMES[bankOffer.bank.name];

  const headerActions: React.ReactElement[] = [];
  if (bankOffer.extId !== null)
    headerActions.push(
      <Tooltip key={bankOffer.extId + 'status-button'} title="Обновить статус">
        <Button
          isSquare
          size="small"
          onClick={() => handleChangeEuBankStatus(bankOffer?.extId || '')}
        >
          <ReloadOutlined className="euras-bank-item__icon" />
        </Button>
      </Tooltip>
    );

  const name = bank?.fullname || bankIconName?.name;
  const icon = bank?.icon || bankIconName?.icon;

  if (!name) return null;
  return (
    <OfferCard
      className="bank-item"
      status="warning"
      statusText={bankOffer.status.name}
      extId={bankOffer.extId || undefined}
    >
      <OfferCard.Header
        title={name}
        icon={icon}
        isWaitingOffer
        headerActions={headerActions}
        requestBodyInfo={{
          bankName: bankOffer.bank.name,
          responsePrimaryBody: bankOffer.responsePrimaryBody,
          responseSendedBody: bankOffer.responseSendedBody
        }}
      />
    </OfferCard>
  );
};

export default EurasWaitingItem;
